import { isHomepagePath } from '@seek/seek-jobs-seo';
import { useEffect, useRef } from 'react';

import { useLocationPromptFeatureFlag } from 'src/store/featureFlags/hooks';
import { useSelector } from 'src/store/react';
import { selectIsResultsLoading, selectPathname } from 'src/store/selectors';

export const useKeywordFieldProps = ({
  search,
  isTooltipShown = false,
}: {
  search: () => void;
  isTooltipShown: boolean;
}) => {
  const wasSearched = useRef(false);

  const resultsLoading = useSelector(selectIsResultsLoading);

  useEffect(() => {
    if (!resultsLoading) {
      // Results are no longer loading so assume a search just finished
      wasSearched.current = false;
    } else {
      wasSearched.current = true;
    }
  }, [resultsLoading]);

  const autoFocusWhereOnSearchBlur = useLocationPromptFeatureFlag();

  const whereRef = useRef<HTMLInputElement | null>(null);

  const keywordDefocus = () => {
    if (autoFocusWhereOnSearchBlur)
      setTimeout(() => {
        if (!wasSearched.current) {
          whereRef.current?.focus();
        }

        wasSearched.current = false;
      }, 200);
    else {
      search();
    }
  };

  const currentPath = useSelector(selectPathname);
  return {
    whereRef,
    keywordFieldProps: {
      onSuggestionSelected: keywordDefocus,
      onInputBlur: keywordDefocus,
      onReturn: keywordDefocus,
      onClear:
        autoFocusWhereOnSearchBlur && isHomepagePath(currentPath)
          ? () => {}
          : search,
      isTooltipShown,
    },
    keywordDefocus,
  };
};
